import {
  Form,
  Header,
  Button,
  Message,
  Checkbox,
  Divider,
  Image,
} from "semantic-ui-react";

import moment from "moment";
import { render } from "react-dom";
import { useEffect, useState, useContext } from "react";
import OtpInput from "react-otp-input";
import { AuthContext } from "../AuthContext";
import CodeExpiration from "./CodeExpiration";
const Login = (props) => {
  const {
    email,
    phone,
    onChange,
    handleCreatePass,
    isReady,
    passcode,
    handleValidatePass,
    loading,
    errorMessage,
    isRemember,
    setRemember,
    onChangePasscode,
    isEmailLogin,
    setLoginMethod,
  } = props;
  const { loginContext, themeColor } = useContext(AuthContext);

  const handleRemember = () => {
    setRemember(!isRemember);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        with: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <svg
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100vw",
          minWidth: "100%",
          height: "320px",
          zIndex: 0,
          opacity: 0.13,
          pointerEvents: "none",
          right: 0, // make sure it stretches fully
        }}
        viewBox="0 0 1440 320"
        preserveAspectRatio="none" // <- This is the key
      >
        <path
          d="M0,288L48,272C96,256,192,224,288,218.7C384,213,480,235,576,250.7C672,267,768,277,864,250.7C960,224,1056,160,1152,122.7C1248,85,1344,75,1392,69.3L1440,64V320H0Z"
          fill="#b31d23"
        />
      </svg>
      <Image
        onClick={() => (window.location.href = "/")}
        src="./images/logo.png"
        style={{
          height: "60px",
          zIndex: 1,
          cursor: "pointer",
          margin: "20px",
        }}
      />

      <div
        style={{
          maxWidth: "500px",
          width: "100%",
          backgroundColor: "#F1F1F1",
          padding: "20px",
          zIndex: "1",
          marginTop: "-50px",
          boxShadow: "rgba(50, 0, 0, 0.14) 0px 0 2px 2px",
          borderRadius: "20px",
        }}
      >
        <Form size="large">
          <Header
            content="Dashboard Login"
            subheader={
              !isReady ? "Choose your login method" : "Enter your passcode"
            }
            style={{ textAlign: "center" }}
          />
          {!isReady && (
            <Form.Field style={{ display: "flex", justifyContent: "center" }}>
              <Button.Group>
                <Button
                  className="custom-button"
                  style={{ backgroundColor: isEmailLogin ? themeColor : "" }}
                  icon="mail"
                  primary={isEmailLogin}
                  content="Email"
                  onClick={() => setLoginMethod(true)}
                />
                <Button.Or />
                <Button
                  className="custom-button"
                  style={{ backgroundColor: !isEmailLogin ? themeColor : "" }}
                  icon="phone"
                  primary={!isEmailLogin}
                  content="Phone"
                  onClick={() => setLoginMethod(false)}
                />
              </Button.Group>
            </Form.Field>
          )}
          {!isReady && isEmailLogin && (
            <Form.Input
              icon="mail"
              id="email"
              label="Email"
              placeholder="Email"
              disabled={loading}
              value={email}
              onChange={onChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleCreatePass();
              }}
            />
          )}
          {!isReady && !isEmailLogin && (
            <Form.Input
              icon="phone"
              id="phone"
              label="Phone"
              placeholder="555 555 5555"
              disabled={loading}
              value={phone}
              onChange={onChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleCreatePass();
              }}
            />
          )}
          {!isReady && (
            <Form.Field>
              <Checkbox
                checked={isRemember}
                onChange={handleRemember}
                label="Remember Me"
              />
            </Form.Field>
          )}
          {!isReady && phone && (
            <p>
              <span style={{ fontSize: "10px" }}>
                By clicking "Login" you agree to receive SMS from Stenexus to
                the phone number provided including a One-Time Password for
                logging in. Message and data rates may apply.
              </span>
            </p>
          )}
          {!isReady && email && (
            <span style={{ fontSize: "10px" }}>
              By clicking "Login" you agree to receive email from Stenexus
              including a One-Time Password for logging in.
            </span>
          )}
          {!isReady && (
            <Form.Field>
              <Button
                className="custom-button"
                style={{ backgroundColor: themeColor }}
                size="large"
                content="Login"
                loading={loading}
                disabled={loading}
                primary
                fluid
                onClick={handleCreatePass}
              />
            </Form.Field>
          )}
          {!isReady && (
            <Divider horizontal section>
              Need an account?
            </Divider>
          )}
          {!isReady && (
            <Form.Field>
              <Button
                className="custom-button"
                size="large"
                content="Sign Up"
                secondary
                fluid
                onClick={() => (window.location.href = "/signup")}
              />
            </Form.Field>
          )}
          {isReady && (
            <p>
              Your One-Time Passcode has been sent to your email address. Enter
              the passcode here to login. Code will expire in 10 minutes.
            </p>
          )}
          {isReady && <CodeExpiration />}
          {isReady && (
            <div>
              <OtpInput
                containerStyle={{
                  justifyContent: "space-between",
                  margin: "20px",
                }}
                inputStyle={{
                  padding: "00px",
                  width: "50px",
                  height: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "2em",
                  fontWeight: "900",
                  color: themeColor,
                }}
                value={passcode}
                onChange={onChangePasscode}
                numInputs={6}
                renderSeparator={<span>-</span>}
                renderInput={(props) => (
                  <input
                    {...props}
                    autoComplete="new-password"
                    autoFill="none"
                    type="text"
                  />
                )}
                shouldAutoFocus
              />
            </div>
          )}
          {isReady && (
            <Form.Field>
              <Button
                className="custom-button"
                style={{ backgroundColor: themeColor }}
                size="large"
                content="Submit"
                loading={loading}
                disabled={loading}
                primary
                fluid
                onClick={handleValidatePass}
              />
            </Form.Field>
          )}
          {isReady && (
            <Form.Field>
              <Divider horizontal section>
                Need a new code?
              </Divider>
            </Form.Field>
          )}
          {isReady && (
            <Form.Field style={{ display: "flex", justifyContent: "center" }}>
              <a href="/">Login again to resend</a>
            </Form.Field>
          )}
          {errorMessage && <Message visible error content={errorMessage} />}
        </Form>
      </div>

      <div
        style={{
          zIndex: 1,
          marginTop: "80px",
          height: "20px",
        }}
      >
        <span style={{ color: "#888888", fontSize: "10px" }}>
          &copy; {moment().format("YYYY")} Stenexus, LLC. All Rights Reserved.
        </span>
      </div>
    </div>
  );
};
export default Login;
